import type { ModuleNav } from '@saas/ui';

export const EXPENSE_ADMIN_ROLES = ['owner', 'admin'];

export const expenseNav: ModuleNav = {
  module: 'expense',
  items: [
    { label: '経費精算', to: '/expense', icon: 'receipt', end: true, description: '領収書から申請を作る' },
    { label: '新しい経費', to: '/expense/new', icon: 'photo_camera', description: '領収書を撮る・選ぶ' },
    { label: '検索（電帳法）', to: '/expense/search', icon: 'search', description: '日付・金額・取引先' },
    { label: '仕訳 CSV', to: '/expense/journal-export', icon: 'table_view', roles: EXPENSE_ADMIN_ROLES, permission: ['expense.export.execute'], description: '弥生 / freee / MF' },
  ],
  admin: [
    { label: '勘定科目', to: '/expense/account-codes', icon: 'list', roles: EXPENSE_ADMIN_ROLES, permission: ['expense.account_code.manage'] },
    { label: '入力期限レポート', to: '/expense/reports/input-deadline', icon: 'schedule', roles: EXPENSE_ADMIN_ROLES, permission: ['expense.report.read'], description: '期限超過の件数（税務調査向け）' },
  ],
};
